import React from 'react';
import { motion } from 'framer-motion';
import { PulseLoader } from 'react-spinners';
import { styled } from '@stitches/react';

// 加载动画容器样式
const LoaderContainer = styled('div', {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'var(--background-color)',
  zIndex: 9999,
});

// 公司logo区域
const LogoContainer = styled('div', {
  marginBottom: 'var(--spacing-xl)',
  textAlign: 'center',
});

// 公司名称样式
const CompanyName = styled('h1', {
  fontSize: 'var(--font-size-display)',
  fontWeight: 'var(--font-weight-bold)',
  color: 'var(--primary-color)',
  margin: 'var(--spacing-lg) 0',
});

// 加载提示文本
const LoadingText = styled('p', {
  fontSize: 'var(--font-size-md)',
  color: 'var(--text-secondary)',
  marginTop: 'var(--spacing-md)',
});

// 不同淡出阶段的动画变体
const containerVariants = {
  hidden: { opacity: 1 },
  visible: { opacity: 1 },
  exit: { opacity: 0, transition: { duration: 0.5 } },
};

// 加载组件属性
interface LoaderProps {
  isLoading: boolean;
}

// 加载动画组件
const Loader: React.FC<LoaderProps> = ({ isLoading }) => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={containerVariants}
      style={{ display: isLoading ? 'block' : 'none' }}
    >
      <LoaderContainer>
        <LogoContainer>
          {/* 这里可以放置公司Logo图片 */}
          <CompanyName>BITENGINE</CompanyName>
        </LogoContainer>
        
        <PulseLoader color="var(--primary-color)" size={15} />
        
        <LoadingText>加载中，请稍候...</LoadingText>
      </LoaderContainer>
    </motion.div>
  );
};

export default Loader; 